import { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useConfig } from '../contexts/ConfigContext.js';

/**
 * Non-redirecting admin check for public pages that show admin-only bits.
 * Returns true once the signed-in user's email is in config.adminEmails.
 */
export function useIsAdmin() {
  const config = useConfig();
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(getAuth(), user => setCurrentUser(user));
    return () => unsubscribe();
  }, []);

  return !!currentUser && (config.adminEmails || []).includes(currentUser.email);
}
